import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    emptyList: {
      closed: 'No closed expense claim',
      pending: 'No pending expense claim',
    },
  },
  fr: {
    emptyList: {
      closed: 'Aucune note de frais traitée',
      pending: 'Aucune note de frais en attente',
    },
  },
} as const);

export default locales;
